<!--sl-page-header header="Assignments" i18n-header>
    <div slot="actions" style="box-sizing: border-box">
        <sl-button (click)="addNew()" type="primary" class="mr-4" i18n>New assignment</sl-button>
        <sl-button (click)="addNew()" i18n>More</sl-button>
    </div>
</sl-page-header-->

    <!--sl-tab-group>
        <sl-tab slot="nav" panel="list" i18n>List</sl-tab>
        <sl-tab slot="nav" panel="map" i18n>Map</sl-tab>
        <sl-tab slot="nav" panel="calendar" i18n>Calendar</sl-tab>

        <sl-tab-panel name="list">
            <ws-assignment-list (assignmentOpen)="onAssignmentOpen($event)"></ws-assignment-list>
        </sl-tab-panel>
        <sl-tab-panel name="map">
            
        </sl-tab-panel>
    </sl-tab-group-->
    <ws-assignment-map></ws-assignment-map>